module.exports = __webpack_public_path__ + "assets/icon_performance_green.56508b0b.svg";